import React from "react";
import { sellRules } from "@/lib/gems";

// The selling rules, shown beside every sell form (operator, 2026-10-16).
export default function GemSellRules({ config, className = "" }) {
  const rules = sellRules(config);
  return (
    <ul className={`text-sm text-muted-foreground list-disc pl-5 space-y-1 ${className}`} data-testid="gem-sell-rules">
      {rules.map((r) => <li key={r}>{r}</li>)}
    </ul>
  );
}
